var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStethoscopeIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1236_3785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0337 16.6266V26.1914C25.0337 27.3223 24.1138 28.2422 22.9829 28.2422H12.5532C11.4224 28.2422 10.5024 27.3223 10.5024 26.1914V24.9023H8.74463V26.1914C8.74463 28.2914 10.4532 30 12.5532 30H22.9829C25.0829 30 26.7915 28.2914 26.7915 26.1914V16.6359C26.2005 16.7246 25.6018 16.7188 25.0337 16.6266Z",
    fill: "url(#paint0_linear_1236_3785)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9419 14.9414C28.1262 14.9414 29.897 13.1707 29.897 10.9863C29.897 8.802 28.1262 7.03125 25.9419 7.03125C23.7576 7.03125 21.9868 8.802 21.9868 10.9863C21.9868 13.1707 23.7576 14.9414 25.9419 14.9414Z",
    fill: "url(#paint1_linear_1236_3785)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5569 22.2656V20.288C14.8632 19.5479 17.4257 17.0306 18.3075 13.8913C18.443 13.4088 18.1477 12.9104 17.6595 12.7975L17.4639 12.7522L18.919 6.63844C19.4606 4.36271 17.8924 2.1535 15.6131 1.87359C15.2978 0.79248 14.2985 0 13.1169 0C11.6822 0 10.4834 1.14984 10.4447 2.56324C10.4052 4.00002 11.5302 5.27344 13.1169 5.27344C14.2095 5.27344 15.1462 4.59574 15.5304 3.63891C16.7106 3.86092 17.4945 5.03145 17.2089 6.23145L15.7514 12.3557L15.3727 12.268C14.9209 12.1635 14.4659 12.4277 14.3326 12.8716C13.7081 14.9528 11.7475 16.4062 9.56475 16.4062C7.38201 16.4062 5.42135 14.9528 4.79686 12.8717C4.66361 12.4277 4.20828 12.1637 3.75682 12.2681L3.37813 12.3557L1.92061 6.23145C1.6352 5.0325 2.41795 3.86109 3.59908 3.63891C3.98334 4.59574 4.92002 5.27344 6.01256 5.27344C7.44729 5.27344 8.64606 4.12359 8.68479 2.7102C8.72574 1.2215 7.53348 0 6.04912 0C4.86102 0 3.85432 0.790078 3.52584 1.8723C1.24537 2.14676 -0.332674 4.35592 0.210548 6.63844L1.66555 12.7522L1.47002 12.7975C0.981642 12.9105 0.686564 13.4089 0.822033 13.8913C1.70199 17.0244 4.25996 19.5465 7.57256 20.288V22.2656C7.57256 22.751 7.96608 23.1445 8.45147 23.1445H10.678C11.1634 23.1445 11.5569 22.751 11.5569 22.2656Z",
    fill: "url(#paint2_linear_1236_3785)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1236_3785",
    x1: 8.99655,
    y1: 27.3253,
    x2: 26.7915,
    y2: 27.3253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1236_3785",
    x1: 22.0972,
    y1: 13.3594,
    x2: 29.897,
    y2: 13.3594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1236_3785",
    x1: 0.367187,
    y1: 18.5156,
    x2: 19.0264,
    y2: 18.5156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1236_3785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscopeIc);
export default __webpack_public_path__ + "static/media/stethoscope_ic.be03faaeddc2e2f395a6a3c5e055ad03.svg";
export { ForwardRef as ReactComponent };